import { Location } from '@angular/common';
import { AfterViewInit, Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit, AfterViewInit {

  constructor(private location: Location) { }

  goBack(): void {
    this.location.back();
  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {

  }

}
